export const GET_FOLLOWED_USER_INFO = 'GET_FOLLOWED_USER_INFO';
export const REFUSE_FOLLOWED = 'REFUSE_FOLLOWED';
export const AGREE_FOLLOWED = 'AGREE_FOLLOWED';
export const GET_FOLLOWED_USERS = 'GET_FOLLOWED_USERS';
export const CANCEL_SOMEONE_FOLLOWED = 'CANCEL_SOMEONE_FOLLOWED';
export const GET_USER_LIST_FOLLOW = 'GET_USER_LIST_FOLLOW';
export const GET_USER_LIST_FOLLOW_ME = 'GET_USER_LIST_FOLLOW_ME';
export const GET_RECOMMEND_FOLLOW = 'GET_RECOMMEND_FOLLOW';
export const FOLLOW_SOMEONE = 'FOLLOW_SOMEONE';
export const CANCEL_SOMEONE_FOLLOW_ME = 'CANCEL_SOMEONE_FOLLOW_ME';
export const GET_GROUP_FOLLOW = 'GET_GROUP_FOLLOW';
export const GET_USER_FOLLOW_SETTING = 'GET_USER_FOLLOW_SETTING';
export const SET_USER_FOLLOW_SETTING = 'SET_USER_FOLLOW_SETTING';
